<template>
    <div class="container">
        <!-- <draggable @end="onEnd">
        </draggable> -->
        <!-- <div class="circle" draggable="true" @drag="onDragging">11</div> -->

    </div>
</template>


<script>
export default {

    data() {
        return {

        }
    },
    methods: {
        onStart(e) {
            console.log(e);
        },
        onEnd(e) {
            // console.log('end>>', e);
        },
        onDragging(event) {
            console.log('event: ', event);
            return
            // // 计算相对于起始位置的偏移量
            // this.currentOffset = {
            //     x: event.clientX - this.initialOffset.x,
            //     y: event.clientY - this.initialOffset.y,
            // };
            // console.log('Current Offset:', this.currentOffset);
        },
    },

};
</script>

<style scoped>
.circle {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    border: 1px solid pink;
}
</style>